import { css } from "emotion";

import { colors, fonts, getRGBA } from "@cobliteam/base-components";

const body = css`
  padding: 15px 20px 20px;
`;

const reachedSpeedRow = css`
  margin-top: 13px;
  display: flex;
  align-items: center;
  height: 25px;
`;

const infoRow = css`
  margin-top: 10px;
`;

const addressPlaceholder = css`
  vertical-align: middle;
`;

const badge = css`
  font-weight: ${fonts.weight.regular};
  background-color: ${getRGBA(colors.gray.dark, 0.1)};
  color: ${colors.gray.dark};
  border-radius: 3px;
  padding: 4px 10px;
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.medium};
  display: flex;
  align-items: center;
  margin-left: 15px;

  > svg {
    margin-right: 10px;
    width: 12px;
    height: 12px;
  }
`;

export default {
  body,
  reachedSpeedRow,
  infoRow,
  addressPlaceholder,
  badge,
};
